//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import QMenuTree from '../QMenuTree.vue'
export default {
  components: { QMenuTree },
  props: {
    value: {
      type: String,
      default: ''
    },
    variables: {
      type: Object,
      default: () => ({})
    },
    inputHandler: {
      type: Function,
      required: true
    }
  },

  data () {
    return {
    }
  },

  computed: {
    toolbar () {
      return [
        ['left', 'center', 'right', 'justify'],
        ['bold', 'italic', 'underline', 'strike'],
        ['undo', 'redo'],
        [{
          label: this.$q.lang.editor.formatting,
          icon: this.$q.iconSet.editor.formatting,
          list: 'no-icons',
          options: ['p', 'h3', 'h4', 'h5', 'h6', 'code']
        }],
        ['viewsource'],
        ['token']
      ]
    }
  },
  methods: {
    add (name) {
      const edit = this.$refs.editor
      edit.caret.restore()
      edit.runCmd('insertText', `{{${name}}}`)
      edit.focus()
    }

  }
}
